<template>
  <b-card
    title="Arquivos"
  >
    <b-tabs v-if="data.lead_id">

      <b-tab v-if="register.approved.length">
        <template #title>
          <feather-icon icon="CheckSquareIcon" />
          <span>Validados</span>
        </template>

        <div>
          <p
            v-for="file of register.approved"
            :key="file"
          >
            {{ file }}
          </p>
        </div>
      </b-tab>
      <b-tab v-if=" register.denied_files.length">
        <template #title>
          <feather-icon icon="XSquareIcon" />
          <span> Pendentes </span>
        </template>

        <Form
          :files="invalidFiles"
          :items="deniedFiles"
          @upload-file="$emit('upload', invalidFiles)"
        />
      </b-tab>

      <b-tab v-if="register.in_analysis.length">
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span> Em Análise </span>
        </template>

        <p
          v-for="file of register.in_analysis"
          :key="file"
        >
          {{ file }}
        </p>

      </b-tab>

      <!-- <b-tab v-if="register.status_id === 19">
        <template #title>
          <feather-icon icon="UserIcon" />
          <span> Desqualificados </span>
        </template>

        <p
          v-for="file of sendedFiles.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.name === value.name
            ))
          )"
          :key="file.name"
        >
          <span v-if="userFileBySelectedProducts.length > 0">
            <span v-if="!userFileBySelectedProducts.find(item => file.name === item.fileName)">
              {{ file.name }}
            </span>
          </span>

          <span v-else> {{ file.name }}</span>
        </p>

      </b-tab> -->

      <b-tab v-if="register.missing_files.optional.length">
        <template #title>
          <feather-icon icon="UserIcon" />
          <span> Opcionais </span>
        </template>

        <b-form>

          <Form
            :items="register.missing_files.optional.map(item => ({ name: item, isRequired: false }))"
            :files="optionalFiles"
            @upload-file="$emit('upload', optionalFiles)"
          />
        </b-form>

      </b-tab>
    </b-tabs>

    <Form
      v-else
      :files="files"
      :items="registrationFilesPending"
      @upload-file="$emit('upload', files)"
    />

  </b-card>
</template>

<script>

import {
  BCard,
  BTabs,
  BTab,
} from 'bootstrap-vue'

import Form from './Form.vue'

export default {
  components: {
    BCard,
    BTabs,
    Form,
    BTab,
  },
  props: {
    register: {
      type: Object,
      required: true,
    },

    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      invalidFiles: {},
      optionalFiles: {},
      files: {},
    }
  },

  computed: {
    registrationFilesPending() {
      if (!this.register.missing_files) return []
      const required = this.register.missing_files.required.map(item => ({
        name: item,
        isRequired: true,
      }))

      const optionals = this.register.missing_files.optional.map(item => ({
        name: item,
        isRequired: false,
      }))

      return [...required, ...optionals]
    },

    deniedFiles() {
      return this.register.denied_files.map(item => ({ name: item, isRequired: true }))
    },
  },

}
</script>
